import { render } from "./TableLoading.vue?vue&type=template&id=2bb71dc7&scoped=true"
const script = {}

import "./TableLoading.vue?vue&type=style&index=0&id=2bb71dc7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb71dc7"]])

export default __exports__